import { getConfluenceApiUrl, getConfluenceCloudID, getAccessToken, confluenceOauth2 } from './confluenceUtils'

const importFromConfluence = async (url: string) => {
  await confluenceOauth2(window.location.href, window.location.origin)
  const cloudID = await getConfluenceCloudID()
  const apiUrl = getConfluenceApiUrl(url, cloudID)

  const reqBody = JSON.stringify({
    apiUrl,
    accessToken: getAccessToken(),
    apiMethod: 'GET',
  })

  const res = await fetch('/api/confluenceRest', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: reqBody,
  })

  const json = await res.json()

  const {
    apiRes: {
      results: [
        {
          body: {
            export_view: { value },
          },
        },
      ],
    },
  } = json

  return value
}

const useImportFromConfluence = () => {
  return { importFromConfluence }
}

export const confluenceLink = 'atlassian.net/wiki/spaces/'
export default useImportFromConfluence
